import React from 'react';
import './ProjectSingle.css';

// Import necessary components
import { PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const ProjectSingle = () => {

  // Get Project details passed via router state
  const location = useLocation();
  const project = location.state;

  // Split challenges into two halves
  const halfwayPoint = Math.ceil(project.challenges.length / 2);
  const firstHalfChallenges = project.challenges.slice(0, halfwayPoint);
  const secondHalfChallenges = project.challenges.slice(halfwayPoint);

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={project.title} page={"Project Single"} />

      <section className='project-single page-single'>

        <div className='project-info'>

          <div className='project-intro'>

            {/* Project Image */}
            <div className='image'>
              <img src={project.image} alt={project.title} />
            </div>

            {/* Sidebar with Project details */}
            <PageSidebar
              heading={'Project'}
              details={project.details}
            />

          </div>

          <div className='page-info'>
            <div className='content'>

              {/* Project Title */}
              <h3 className='main-heading'>{project.title}</h3>

              {/* Project Description */}
              {project.paragraphs.map((paragraph, index) => (
                <p key={index} className={index === 0 ? 'important' : ''}>
                  {paragraph}
                </p>
              ))}

              {/* Project Challenges Section */}
              <div className='sub-section project-challenges'>
                <h3 className='sub-heading'>Project Challenges:</h3>
                <p>Key logistical and operational challenges encountered during the {project.title} water supply and delivery project.</p>

                <div className='box-container'>
                  <div className='box-content'>
                    {/* First half of challenges */}
                    <ul>
                      {firstHalfChallenges.map((challenge, index) => (
                        <li key={index}><FaCheck className='icon' />{challenge}</li>
                      ))}
                    </ul>
                  </div>

                  <div className='box-content'>
                    {/* Second half of challenges */}
                    <ul>
                      {secondHalfChallenges.map((challenge, index) => (
                        <li key={index}><FaCheck className='icon' />{challenge}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Project Solution Section */}
              <div className='sub-section'>

                <div className='box-container'>

                  <div className='box-content'>
                    <h3 className='sub-heading'>Project Solutions:</h3>
                    <p>We addressed these operational challenges with practical, efficient solutions tailored to the project.</p>

                    {/*Project Solutions List */}
                    <ul>
                      {project.solutions.map((solution, index) => {
                        return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                      })}
                    </ul>
                  </div>

                  <div className='box-content sub-image'>
                    <img src={project.gallery[0]} alt="Project Preview" />
                  </div>

                </div>

              </div>

              {/* Project Results Section */}
              <div className='sub-section'>

                <div className='box-container'>

                  <div className='box-content sub-image'>
                    <img src={project.gallery[1]} alt="Project Preview" />
                  </div>

                  <div className='box-content'>
                    <h3 className='sub-heading'>Project Results:</h3>
                    <p>The project achieved reliable water supply, improved service efficiency, and strong customer satisfaction.</p>

                    {/* Project Results */}
                    <ul>
                      {project.results.map((result, index) => {
                        return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                      })}
                    </ul>
                  </div>

                </div>

              </div>

            </div>
          </div>

        </div>

      </section>

    </> 
  );
}

export default ProjectSingle;